import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	headerMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmActionText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelActionText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contentMessageIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	headerMessage: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.header-message',
		defaultMessage: 'Remove this Loom video link?',
		description:
			'A header of a modal in a Jira issue to explain this modal is used to confirm removing a Loom link.',
	},
	contentMessage: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message',
		defaultMessage: 'This will unlink the video from the issue.',
		description:
			'Content of a modal on Jira issue letting users know that removing the Loom link just un-links the video from the issue and does not delete the video itself.',
	},
	confirmActionText: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.confirm-action-text',
		defaultMessage: 'Remove',
		description:
			'Confirmation button in a modal dialog in a Jira issue that will remove a Loom link when clicked.',
	},
	cancelActionText: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.cancel-action-text',
		defaultMessage: 'Cancel',
		description:
			'Cancel button in a modal dialog in a Jira issue that will close the modal and cancel the operation to remove a Loom link.',
	},
	contentMessageIssueTermRefresh: {
		id: 'issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message-issue-term-refresh',
		defaultMessage: 'This will unlink the video.',
		description:
			'Content of a modal on Jira issue letting users know that removing the Loom link just un-links the video from the issue and does not delete the video itself.',
	},
});
